
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.5 2.5V29.4998C24.5 30.6044 23.6046 31.4998 22.5 31.4998H9.5C8.39543 31.4998 7.5 30.6044 7.5 29.4998V2.5C7.5 1.39543 8.39543 0.5 9.5 0.5H11H21H22.5C23.6046 0.5 24.5 1.39543 24.5 2.5Z","fill":"white"}}),_c('path',{attrs:{"d":"M5.5 19V15.5M26.5 5.5V2.5M26.5 10.5V7.5M11 0.5H9.5C8.39543 0.5 7.5 1.39543 7.5 2.5V29.4998C7.5 30.6044 8.39543 31.4998 9.5 31.4998H22.5C23.6046 31.4998 24.5 30.6044 24.5 29.4998V2.5C24.5 1.39543 23.6046 0.5 22.5 0.5H21M11 0.5H21M11 0.5C11 1.60457 11.8954 2.5 13 2.5H19C20.1046 2.5 21 1.60457 21 0.5","stroke":"black","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 7C10 5.89543 10.8954 5 12 5H20C21.1046 5 22 5.89543 22 7V14C22 15.1046 21.1046 16 20 16H12C10.8954 16 10 15.1046 10 14V7Z","fill":"#0093FF"}}),_c('path',{attrs:{"d":"M10 20C10 19.4477 10.3838 19 10.8571 19H21.1429C21.6162 19 22 19.4477 22 20C22 20.5523 21.6162 21 21.1429 21H10.8571C10.3838 21 10 20.5523 10 20Z","fill":"#0093FF"}})])
          )
        }
      }
    